/**
 * Utility functions for currency formatting
 */

/**
 * Format a number as currency
 * @param value - The numeric value to format
 * @param currency - Currency code (default: 'USD')
 * @returns Formatted currency string or 'N/A' if value is null/undefined
 */
export const formatCurrency = (value?: number, currency: string = 'USD'): string => {
  if (!value && value !== 0) return 'N/A';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

